/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { ButtonList, CosmosButtonProps, CosmosCard, CosmosRichText } from "@components/elements";
import { SlimContactCardFragment } from "@cosmos/hygraph-schema";

import { css } from "@panda/css";
import { Flex } from "@panda/jsx";

const cardStyles = css({
	paddingInline: "eds.dimension.32",
	smDown: {
		paddingInline: "eds.dimension.24",
	},
	_chrome142: {
		backdropFilter: "none!",
	},
});

export const SlimContactCard = ({
	slimContactCardDesc,
	buttons,
}: SlimContactCardFragment): React.JSX.Element | null => {
	if (!buttons?.length && !slimContactCardDesc) return null;
	const cosmosButtons = buttons?.map((button): CosmosButtonProps => {
		return {
			...button,
			size: "lg",
			analytics: {
				eventCategory: "button",
				interactionType: "click",
				eventAction: "navigation",
				eventLabel: button.name || button.label || "",
				eventValue: {
					component: "SlimContactCard",
				},
			},
		};
	});

	return (
		<CosmosCard className={cardStyles} variant="material">
			<Flex
				justifyContent="space-between"
				alignContent="stretch"
				className={css({
					gap: "eds.dimension.32",
					smDown: { flexDirection: "column", gap: "eds.dimension.24" },
				})}
			>
				<CosmosRichText
					className={css({
						"&.cosmos-rich-text": {
							maxWidth: "750px",
							display: "flex",
							alignItems: "center",
						},
					})}
					html={slimContactCardDesc?.html}
				/>
				<ButtonList buttons={cosmosButtons} />
			</Flex>
		</CosmosCard>
	);
};
